import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const SubTitle = ({ className, children, Icon }) => {
  const cn = useClassNames(
    () => [
      'text-xs',
      'mt-1',
      'pl-1',
      '-mb-4',
      'text-slate-500',
      'flex',
      'space-x-1',
      'items-center',
      className,
    ],
    [className],
  );
  return (
    <div data-component="SubTitle" className={cn}>
      {Icon && <Icon size="text" className="fill-current" />}
      <div className="">{children}</div>
    </div>
  );
};

SubTitle.propTypes = {
  Icon: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.node,
};

SubTitle.defaultProps = {
  className: '',
};

export default SubTitle;
